<script>
import { mapState } from 'vuex';

export default {
  name: 'GiftVoucherTemplatePanel',
  props: {
    options: {
      type: Array,
      required: true,
    },
    preview: {
      type: Boolean,
      required: true,
    },
    validated: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState({
      save: state => state.giftVoucherTemplates.save,
    }),
  },
  methods: {
    addValue(event, option) {
      this.$emit('value', option);
    },
    previewTemplate() {
      this.$emit('preview');
    },
    saveTemplate() {
      this.$emit('save');
    },
    closeDialog() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <v-card class="gift-voucher-template-panel">
    <v-flex pa-4>
      <h3 class="text-xs-center">{{ $t('giftVoucherTemplates.edit.preview') }}</h3>
      <v-btn
        @click="previewTemplate"
        :disabled="save.loading"
        color="blue"
        class="white--text mb-3"
        block
      >
        {{
          preview ?
            $t('giftVoucherTemplates.edit.edit') :
            $t('giftVoucherTemplates.edit.preview')
        }}
      </v-btn>
      <h3 class="text-xs-center">{{ $t('giftVoucherTemplates.edit.insertValue') }}</h3>
      <v-btn
        v-for="option in options"
        @click.prevent="addValue($event, option)"
        :key="option.value"
        :disabled="save.loading"
        color="blue"
        class="white--text"
        block
      >
        {{ option.label }}
      </v-btn>

      <h3 class="text-xs-center mt-3">{{ $t('giftVoucherTemplates.edit.action') }}</h3>
      <v-btn
        @click="saveTemplate"
        :disabled="save.loading || validated"
        color="blue"
        class="white--text"
        block
      >
        {{ $t('giftVoucherTemplates.edit.save') }}
      </v-btn>

      <v-btn @click="closeDialog" :disabled="save.loading" class="mt-4" color="error" block>
        {{ $t('giftVoucherTemplates.edit.close') }}
      </v-btn>
    </v-flex>
  </v-card>
</template>

<style lang="scss">
  .gift-voucher-template-panel {
    z-index: 300;
    position: fixed;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    border-radius: 30px 0 0 30px !important;
    background-color: white;
    border: 1px solid lightgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/gift-voucher-templates/GiftVoucherTemplatePanel.vue